const version = '2.0'
const clientType = 'teacher'
const serviceHttp = 'http://m.shurenapp.com/service/http'
// const serviceHttp = 'http://192.168.1.115:8090/codeIgniter/service/http'

export const uploadUrl = 'http://www.shurenapp.com/wma-trusttee-v2/uploadFile/uploadPicture.do?phone_num='
// export const uploadUrl = 'http://192.168.1.100:8080/podo-farm-server/uploadFile/uploadPicture.do?phone_num='

export const uploadMulUrl = 'http://www.shurenapp.com/wma-trusttee-v2/uploadFile/uploadAllPicture.do?phone_num='
// export const uploadMulUrl = 'http://192.168.1.100:8080/podo-farm-server/uploadFile/uploadAllPicture.do?phone_num='

export const serviceCheckNetwork = 'http://m.shurenapp.com/service/networkIsOk'

import { Indicator, Toast } from 'mint-ui'

const httpResponse = (requestObj, response) => {
  Indicator.close()
  response = response.data
  if (typeof response === 'string') {
    response = JSON.parse(response)
  }
  if (response.code === '10006') {
    window.localStorage.clear()
    requestObj.context.$router.push('/sign')
    return
  } else {
    if (response.code === '100') {
      return requestObj.successFun(response)
    } else {
      if (requestObj.not100CodeFun) {
        requestObj.not100CodeFun(response)
      } else {
        Toast(response.msg)
      }
    }
  }
}

export const service = {
  /*
  **设置请求数据
  */
  setPara: (method) => {
    // let loginData = window.localStorage['basic_login_data']
    // if (loginData) {
    //   loginData = JSON.parse(loginData)
    // } else {
    //   loginData = {}
    // }
    // let obj = {method: method, client_type: clientType, version: version, userInfo: loginData, isLoading: false}
    let obj = {method: method, client_type: clientType, version: version, isLoading: false}
    return obj
  },
  /*
  ***参数obj
    context:vue对象, para: 请求参数, successFun: 请求成功, errorFun: 请求失败
    isIndicator: 是否展示加载中, indicatorText: 加载中文字提示, requestType: 请求类别,
    not100CodeFun: 数据获取错误
    demo:
      let obj = {context: this, para: this.get_banner_para, successFun: (response) => {
        this.bannerList = response.data.data
      }}
      service.request(obj)
  */
  request: (obj) => {
    let requestObj = {isIndicator: true, requestType: 'post', url: serviceHttp}
    $.extend(requestObj, obj)
    if (requestObj.isLoading) {
      return
    } else {
      requestObj.isLoading = true
    }
    if (requestObj.isIndicator) {
      if (requestObj.indicatorText) {
        Indicator.open(requestObj.indicatorText)
      } else {
        Indicator.open()
      }
    }

    let loginData = window.localStorage['basic_login_data']
    if (loginData) {
      loginData = JSON.parse(loginData)
    } else {
      loginData = {}
    }
    requestObj.para.userInfo = loginData

    if (requestObj.requestType == 'post') {
      // requestObj.context.$http.post(requestObj.url, requestObj.para).then((response) => {
      Vue.http.post(requestObj.url, requestObj.para).then((response) => {
        requestObj.isLoading = false
        httpResponse(requestObj, response)
      }, (response) => {
        requestObj.isLoading = false
        Indicator.close()
        if (response.status == 0) {
          requestObj.context.$router.push('/networkLess')
          return
        }
        if (requestObj.errorFun) {
          requestObj.errorFun(response)
        } else {
          Toast('网络异常，请重新尝试')
        }
      })
    } else {
      // requestObj.context.$http.get(serviceHttp, requestObj.para).then((response) => {
      Vue.http.get(serviceHttp, requestObj.para).then((response) => {
        requestObj.isLoading = false
        httpResponse(requestObj, response)
      }, (response) => {
        requestObj.isLoading = false
        Indicator.close()
        if (response.status == 0) {
          requestObj.context.$router.push('/networkLess')
          return
        }
        if (requestObj.errorFun) {
          requestObj.errorFun(response)
        } else {
          Toast('网络异常，请重新尝试')
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./C:/vue/2.0/src/service.js